export const SET_SOURCES = "SOURCE/SET_SOURCES";
export const SET_SOURCE = "SOURCE/SET_SOURCE";
export const SET_PAGINATION = "SOURCE/SET_PAGINATION";
